export default __webpack_public_path__ + "static/media/referenzen_intro_web-sm@1x.d085f6ca.jpg";